<template>
  <div id="app">
    <!-- <div class="phone-warning-box">
      <img :src="phoneWarning" class="phone-warning">1
    </div> -->
    <router-view />
  </div>
</template>

<script>
import warterMark from '@/utils/warterMark'
import phoneWarning from '@/assets/images/phone-warning.gif'
// import { isPC } from '@/utils'
export default {
  name: 'App',
  data() {
    return {
      phoneWarning: phoneWarning,
      sIWaterMark: null,
      checkAd: ''
    }
  },
  watch: {
    '$store.getters.name': function(data) {
      warterMark.set(data, 'app', {}, this.checkAd)
      clearInterval(this.sIWaterMark)
      this.sIWaterMark = setInterval(() => {
        warterMark.set(data, 'app', {}, this.checkAd)
      }, 10000)
    }
  },
  created() {
    // 检测浏览器是否开启广告扩展
    this.checkAdExpand()
  },
  mounted() {
    // const evt = 'onorientationchange' in window ? 'orientationchange' : 'resize'
    // window.addEventListener(evt, () => {
    //   if (!isPC()) { location.reload() }
    // })
    window.onfocus = () => {
      // 如果断开就重连
      if (!this.$store.state.websocket.ws && this.$route.path !== '/login') {
        // 重连
        this.$store.dispatch('websocket/init')
      }
    }
  },
  methods: {
    checkAdExpand() {
      const xhr = new XMLHttpRequest()
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status !== 200) {
          // 含有广告插件
          this.checkAd = 'AD'
          warterMark.set(this.$store.getters.name, 'app', {}, 'AD')
        }
      }
      xhr.open('GET', process.env.VUE_APP_BASE_API + '/AD/checkAd', true)
      xhr.send(null)
    }
  }
}
</script>

<style lang='scss' scoped>
.phone-warning-box{
  position: fixed;
  left:0;
  right:0;
  width:100%;
  height:100%;
  background: rgba(0,0,0,0.7);
  z-index:9999;
  text-align:center;
  .phone-warning{
    width:400px;
    margin-top:200px;
  }
}
@media (max-height: 768px) and (max-width: 1200px) and (orientation : landscape) {
  // 横屏的时候不用显示手机翻转提示语
  .phone-warning-box{
    display:none;
  }
}
@media (min-width: 768px) {
  // 如果最小宽度都768了，就不需要翻转了
  .phone-warning-box{
    display:none;
  }
}
</style>
